if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return; 
      

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      /*** if limited product do not allow add to cart - starts ***/
      var product_handle = this.form.querySelector('[name=product_handle]').value; //$('#product_handle').val();
      var limited_product_elem = $('.limited-product[data-limited-product="'+ product_handle +'"]')
      if(limited_product_elem.length){
        var $_this = this;
        $.ajax({
            type: 'GET',url: '/cart',dataType: 'json',
            success: function(cart) {
              var can_add_to_cart = false;
              var limit_to_products = limited_product_elem.find('.limit-to-product');
              if(limit_to_products.length){
                limit_to_products.each(function(){
                  for (var j = 0; j < cart.items.length; j++) {
                    var limit_to_product_handle = $(this).data('limit-to-product');
                    if (cart.items[j].handle === limit_to_product_handle) {
                      can_add_to_cart = true; break;
                    }                 
                  }
                });
              }
              
              if(can_add_to_cart == true){
                /*** DUPLICATE CODE - starts ***/
                const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                config.body = JSON.stringify({
                  ...JSON.parse(serializeForm($_this.form)),
                  items: items,
                  sections: $_this.cartNotification.getSectionsToRender().map((section) => section.id),
                  sections_url: window.location.pathname
                });

                fetch(`${routes.cart_add_url}`, config)
                  .then((response) => response.json())
                  .then((response) => {
                    if (response.status) {
                      $_this.handleErrorMessage(response.description);
                      return;
                    }
          
                    $_this.cartNotification.renderContents(response);
                  })
                  .catch((e) => {
                    console.error(e);
                  })
                  .finally(() => {
                    submitButton.classList.remove('loading');
                    submitButton.removeAttribute('aria-disabled');
                    $_this.querySelector('.loading-overlay__spinner').classList.add('hidden');
                  });
                /*** DUPLICATE CODE - ends ***/
              } else {
                alert(msg_purchased_only_with_skis);
                submitButton.classList.remove('loading');
                submitButton.removeAttribute('aria-disabled');
                $_this.querySelector('.loading-overlay__spinner').classList.add('hidden');
              }

            },
            error: function(xhr, status, error) {
                console.error('Limit check failed. Error fetching cart: ' + error);
            }
        });
        return;
      }
      /*** if limited product do not allow add to cart - ends ***/
      
      // add binding info
      var items = [];      
      const binding = document.getElementById('binding_id');
      if (binding) {
        var variantID = document.querySelector('[name="id"]').value;
        var bindingID = binding.getAttribute('data-binding_id');
        if (bindingID !== 'null' && bindingID.length > 0) {
          items.push({
            quantity: document.querySelector('input[name="quantity"]').value,
            id: bindingID,
            properties: {
              'vid': variantID
            }
          });
        }
      }
        
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        items: items,
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
